import { SsoData } from "../models/login.models";

/** Static-method namespace for retrieving single sign-on (SSO) data from iMIS SSO pages. */
export class LoginUtility {

    /**
     * Fetches an SSO page and extracts the refresh token and redirect URL from its rendered form, for use in an SSO handoff flow.
     * @param pageUrl The URL of the SSO page to fetch.
     * @returns A promise resolving to the extracted SSO data, including the refresh token, redirect URL, and the full raw response string.
     */
    public static async getSsoDataFromSsoPageUrl(pageUrl: string): Promise<SsoData> {
        let response = await jQuery.get(pageUrl);
        let jResponse = jQuery(response);
        
        let refreshToken = jResponse.find("input[name=refresh_token]").val().toString();
        let redirectUrl = jResponse.attr("action");
        return {
            redirectUrl,
            refreshToken,
            fullResponseString: response
        };
    }

}